import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';

import PickupOrder from '../../../models/PickupOrder';
import PickupOrderListItem from '../../../models/PickupOrderListItem';

import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import EditGoStepperModal from './EditGoStepperModal';
import tableIcons from '../../../utils/editTableIcons';

import style from './ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      paddingTop: '25px',
    },
    piecesWeightTextField: {
      width: '50px'
    },
    errorColor: {
      color: 'red'
    },
    piecesWeightTextFieldRemarks: {
      width: '772px',
    },
    textField: {
      marginTop: 0,
      marginBottom: 0,
    },
    inputTextFieldTable: {
      fontSize: '0.8125rem',
      color: 'var(--primaryblue)', 
    },

    awbWrapper: {
      width: '200px',
      display: 'flex',
      justifyContent: 'space-between',  
    },
    weightWrapper: {
      minWidth: '150px',
    },
    returned: {
      marginTop: '16px'
    },
    number: {
      width: '45%'
    },
    pieces: {
      width: '15%'
    },
    weight: {
      width: '25%'
    },
    checkboxPrimaryScope: {
      '& .MuiCheckbox-colorSecondary': {
        color: 'white',
      },
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: 'white',
      },
      '& .MuiCheckbox-root': {
        padding: '6px',
      },
      '& .MuiCheckbox-root .MuiSvgIcon-root': {
        fontSize: '18px',
      },
    },
    '@media (max-width: 1900px)': {
      piecesWeightTextFieldRemarks: {
        width: '532px',
      },
    },
    '@media (max-width: 1600px)': {

      piecesWeightTextFieldRemarks: {
        width: '392px',
      },
      tableWrapper: {
        '& td': {
          paddingRight: '22px',
          paddingLeft: '23px',
          
        }
      }
    }
  });

import pickupOrderRemote from '../../../api/pickupOrderRemote';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import store from '../../../store/index';
import cartRemote from '../../../api/cartRemote';
import { updateWholeCart, receiveCart } from '../../../store/actions/cartAction';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stepper, Step, StepLabel } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import SplitGoStepperModal from './SplitGoStepperModal';
import PaymentPageContainer from '../paymentPageCommon/PaymentPageContainer';
import paymentsRemote from '../../../api/paymentsRemote';
import type PaymentsPO from '../../../models/PaymentsPO';

interface CommonOrderTableProps extends RouteComponentProps {
  classes: any;
  pickupOrder: PickupOrder;
  setState: Function;
  editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } };
  type: string;
  lastAwbDeletionWarning: ((callback: () => void) => void);
  userRole?: string | any;
};

const commonOrderTable = (props: CommonOrderTableProps) => {

  const [editGoModalOpen, setEditGoModalOpen] = React.useState<boolean>(false);
  const [selectedAwbs, setSelectedAwbs] = React.useState<PickupOrderListItem[]>([]);
  const [loadingCart, setLoadingCart] = React.useState<boolean>(false);
  const [showPaymentModal, setShowPaymentModal] = React.useState<boolean>(false);
  const [newPoForPayment, setNewPoForPayment] = React.useState<string | null>(null);
  const [newPoPayments, setNewPoPayments] = React.useState<PaymentsPO | null>(null);
  const [activeStep, setActiveStep] = React.useState<number>(0);
  const [stepperOpen, setStepperOpen] = React.useState<boolean>(false);
  const selectableGoAwbs = selectedAwbs.filter((awb: any) => !awb.converted_to_po);

  const handleCreatePickupOrder = async () => {
    if (selectedAwbs.length === 0) return;
    if (props.type === 'go') {
      if (selectableGoAwbs.length === 0) return;
        setStepperOpen(true);
        setActiveStep(0);
    } else {
        setLoadingCart(true);
        try {
            for (const awb of selectedAwbs) {
                await cartRemote.addAirwayBillToCart(awb.code, awb.number.toString(), awb.version || 1);
            }
            // Refresh cart to ensure Redux is fully synced before redirect
            store.dispatch(receiveCart(true) as any);
            props.history.push('/cart');
        } catch(e) {
            console.error("Error creating PO", e);
            setLoadingCart(false);
        }
    }
  };

  const { classes, pickupOrder } = props;
  const tableData = pickupOrder.list;
  const minWidthWgt: string = pickupOrder.delivered_time ? '130px' : '50px';
  const minWidthPcs: string = pickupOrder.delivered_time ? '90px' : '50px';
  return (
    <div className={ commonStyles.wrapper }>
      <h1 className={ commonStyles.header }> Awbs </h1>
      <div className={ classes.checkboxPrimaryScope }>
        <MaterialTable
          actions={
            props.type === 'go' && props.pickupOrder.allowed_ops.update_awb_address ? [
              {
                icon: () => <AddCircleOutline color="primary"/>,
                tooltip: 'Add Airwaybill & Charges',
                isFreeAction: true,
                onClick: () => setEditGoModalOpen(true)
              }
            ] : undefined
          }
          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

          icons={ tableIcons }

          data = { tableData }

          columns = {[
            { title: 'Airwaybill', field: '', cellStyle: { width:'200px'},
              render: (rowData: PickupOrderListItem) => {

                const styleAwb: string = rowData.returned ? [classes.awbWrapper, classes.returned ].join(' ') : classes.awbWrapper;
                return (
                <Fragment>
                    <div className={ styleAwb }>
                      <span className={classes.number}>{ rowData.code }-{ rowData.number } </span>
                    </div>
                    { rowData.returned ? 
                        <div className={ style.returnToDriverText}>Returned to driver</div>: null
                    }
                    </Fragment>
                  )
              }
            },
            { title: 'Pcs', field: 'pieces', cellStyle: { minWidth: minWidthPcs },
            render: (rowData: PickupOrderListItem) => {
              const deliverPcs: number = rowData.pieces-rowData.not_delivered_pieces;

              return (
                <span >
                  { pickupOrder.delivered_time ? 
                    <span>{ deliverPcs} / { rowData.pieces }</span> :
                    <span >
                      { rowData.returned ? 
                      <span>0 / { rowData.pieces }</span> : 
                      <span>{ rowData.pieces }</span>
                      }
                    </span>
                    }
                </span>
                )
            },
              editComponent: (editProps: any) => {
                return <Fragment>
                    <TextField
                      error={ !editProps.value || props.editErrors.pieces.error }
                      value={ editProps.value }
                      className={ [classes.piecesWeightTextField, classes.textField].join(' ') }
                      margin="normal"
                      onChange={ event => { editProps.onChange(event.target.value) } }
                      aria-describedby="pieces-helper-text"
                      InputProps={{ className: classes.inputTextFieldTable }}
                    />
                    { props.editErrors.pieces.error &&
                      <FormHelperText id="pieces-helper-text" className={ classes.errorColor } >{ props.editErrors.pieces.message }</FormHelperText>
                    }
                  </Fragment>;
              }
            },
            { title: 'Wgt', field: 'weight', cellStyle: {  minWidth: minWidthWgt }, 
              render: (rowData: PickupOrderListItem) => {
                const deliverWgt: number = +(rowData.weight) - +(rowData.not_delivered_weight);
                return (
                  <span>
                    { pickupOrder.delivered_time ? 
                      <span >{ `${(deliverWgt).toFixed(1)}K` } / { `${(+rowData.weight).toFixed(1)}K` }</span> :
                      <span >
                        { rowData.returned ? 
                          <span>0.0K / { `${(+rowData.weight).toFixed(1)}K` } </span> : 
                          <span>{ `${(+rowData.weight).toFixed(1)}K` }</span>
                        }
                      </span>
                    }
                </span>
                )

              },
              editComponent: (editProps: any) => {
                return <Fragment>
                    <TextField
                      error={ !editProps.value || props.editErrors.weight.error }
                      value={ editProps.value }
                      className={ [classes.piecesWeightTextField, classes.textField].join(' ') }
                      margin="normal"
                      onChange={ event => { editProps.onChange(event.target.value) } }
                      aria-describedby="weight-helper-text"
                      InputProps={{ className: classes.inputTextFieldTable }}
                    />
                    { props.editErrors.weight.error &&
                      <FormHelperText id="weight-helper-text" className={ classes.errorColor } >{ props.editErrors.weight.message }</FormHelperText>
                    }
                  </Fragment>;
              }
            },
            { title: 'Remarks', field: 'remarks_text', cellStyle: {  width: '60%' }, 
              editComponent: (editProps: any) => {
                return <TextField
                    value={ editProps.value }
                    multiline={ true }
                    className={ [classes.piecesWeightTextFieldRemarks, classes.textField].join(' ') }
                    margin="normal"
                    onChange={ event => { editProps.onChange(event.target.value) } }
                    rowsMax={ 4 }
                    InputProps={{ className: classes.inputTextFieldTable }}
                  />;
              }
            }
          ]}

          editable = { props.pickupOrder.allowed_ops.update_awb_address ? {
            onRowUpdate: (newData: any, oldData: any) =>
              new Promise<void>((resolve, reject) => {

                const numberRegex: RegExp = new RegExp(/^((\d+(\.\d*)?)|(\.\d+))$/);
                const editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } } = { pieces: { error: false, message: '' }, weight: { error: false, message: '' } };

                if (newData.pieces === '' || !numberRegex.test(newData.pieces)) {
                  editErrors.pieces = { error: true, message: 'No or invalid pieces value' };
                  props.setState({ editErrors });
                  return reject();
                }

                if (newData.weight === '' || !numberRegex.test(newData.weight)) {
                  editErrors.weight = { error: true, message: 'No or invalid weight value' };
                  props.setState({ editErrors });
                  return reject();
                }

                const newPieces: number = parseInt(newData.pieces);
                const oldPieces: number = parseInt(oldData.pieces);
                const newWeight: number = parseFloat(newData.weight);
                const oldWeight: number = parseFloat(oldData.weight);
                
                if (newData.hasOwnProperty('max_pcs') || oldData.hasOwnProperty('max_wgt')) {

                  const maxP: number = newData.max_pcs;
                  const maxW: number = newData.max_wgt;

                  if (newPieces > maxP) {
                    editErrors.pieces = { error: true, message: 'Exceed the total pieces for the AWB' };
                    props.setState({ editErrors });
                    return reject();
                  }

                  if (newWeight > maxW) {
                    editErrors.weight = { error: true, message: 'Exceed the total weight for the AWB' };
                    props.setState({ editErrors });
                    return reject();
                  }
                } else {

                  if (newPieces > oldPieces) {
                    editErrors.pieces = { error: true, message: 'Exceed the total pieces possible for the AWB' };
                    props.setState({ editErrors });
                    return reject();
                  }

                  if (newWeight > oldWeight) {
                    editErrors.weight = { error: true, message: 'Exceed the total weight possible for the AWB' };
                    props.setState({ editErrors });
                    return reject();
                  }
                }

                setTimeout(() => {
                  {
                    const po: PickupOrder = { ...props.pickupOrder };
                    const poListItems: Array<PickupOrderListItem> = [...po.list];
                    const index: number = poListItems.indexOf(oldData);
                    
                    newData.pieces = +newData.pieces;
                    poListItems[index] = newData;
                    po.list = poListItems;
                    if (props.type === 'do') {
                      props.setState({ dropOffOrder: po, editErrors }, () => resolve()); 
                    } else {
                      props.setState({ pickupOrder: po, editErrors }, () => resolve()); 
                    }
                  }
                  
                  resolve();
                }, 1000);
            }),
            onRowDelete: (oldData: PickupOrderListItem) =>
              new Promise<void>((resolve, reject) => {

                setTimeout(() => {
                  const po: PickupOrder = { ...props.pickupOrder };
                  const poListItems: Array<PickupOrderListItem> = [...po.list];
                  const index: number = poListItems.indexOf(oldData);

                  poListItems.splice(index, 1);

                  const saveChanges = () => {
                    po.list = poListItems;

                    if (props.type === 'do') {
                      props.setState({ dropOffOrder: po }, () => resolve());
                    } else {
                      props.setState({ pickupOrder: po }, () => resolve());
                    }
                  };

                  if (poListItems.length === 0) {
                    props.lastAwbDeletionWarning(saveChanges);
                  } else {
                    saveChanges();
                  }
                }, 1000);
              })
        } : undefined }

        options = {{
          search: false,
          paging: false,
          showTitle: false,
          actionsColumnIndex: -1,
          toolbar: false,
          sorting: false,
          selection: props.type === 'go',
          selectionProps: (rowData: any) => ({ disabled: props.type === 'go' && !!rowData.converted_to_po }),
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },       
        }}
        onSelectionChange={(rows: any) => setSelectedAwbs((rows || []).filter((row: any) => !row.converted_to_po))}
      />
      </div>
      
      {props.type === 'go' && (
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleCreatePickupOrder}
            disabled={selectableGoAwbs.length === 0 || loadingCart}
          >
            {loadingCart ? <CircularProgress size={24} color="inherit" /> : 'Create Pick Up Order'}
          </Button>
        </div>
      )}

      {stepperOpen && (
        <SplitGoStepperModal
          open={stepperOpen}
          onClose={() => setStepperOpen(false)}
          selectedAwbs={selectableGoAwbs}
          goOrder={props.pickupOrder}
          history={props.history}
          userRole={props.userRole as any}
        />
      )}
      {editGoModalOpen && (
        <EditGoStepperModal
          open={editGoModalOpen}
          onClose={() => setEditGoModalOpen(false)}
          goOrder={props.pickupOrder}
          history={props.history}
          userRole={props.userRole}
        />
      )}
    </div>
  );
}

export default withStyles(styles)(withRouter(commonOrderTable));
